<template>
  <section class="banner">
    <!-- here will come some slideshow, that kind of stuff-->
    <div v-if="animate" class="slideshow">
      <div class="sample">        
      </div>
      <div class="typewriter">
        <div>
          <span id="text">_</span>
        </div>
      </div>
      <div class="slide cover"></div>
      <div v-for="id in slideIds" :key="id" class="slide" :id="id"></div>      
    </div>
    <div v-else class="slideshow" :style="{ backgroundImage: `url(${require('@/assets/' + img)})` }" ></div>
  </section>
</template>

<script>
export default {
  name: 'Banner',
  props: ['animate', 'img'],
  data(){
    return{
      slideIds: ["banner-p","banner-k","banner-v","banner-b","banner-t","banner-t2","banner-e"],
      text: "budapest",
      letterAnimation: undefined,
      typewriterAnimation: undefined,
      animationDuration: 20,
      minLetterTime: 1,
      maxLetterTime: 5,
      transitionTime: 3 // css 
    }
  },
  methods: {
      animateLetters(){
        try {
          if(!this._inactive){
            this.slideIds.forEach(id => {
              let startTime = this.getRnd(1, this.animationDuration - this.maxLetterTime)
              let letterTime = this.getRnd(this.minLetterTime, this.maxLetterTime)
              setTimeout(() => { 
                try{
                  document.getElementById(id)?.classList.add('show') 
                } catch { /* empty */ }  
              }, startTime * 1000);
              setTimeout(() => { 
                try{
                  document.getElementById(id)?.classList.remove('show') 
                } catch { /* empty */ }  
              }, (startTime + this.transitionTime + letterTime) * 1000);
            });
          }
        } catch { /* empty */ }        
      },
      animateTypewriter(){
        try {
          if(!this._inactive){
            document.getElementById('text').innerHTML = '_'
            document.querySelector('.typewriter').classList.remove('shrink')
            for (let i = 1; i <= this.text.length; i++) {
              setTimeout(() =>{
                try{
                  document.getElementById('text').innerHTML = this.text.substring(0, i) + '_'
                }
                catch { /* empty */ }
              }, (i == 1 ? 100 : 1000) + 100*i)              
            }
            setTimeout(() =>{
                try{
                  document.querySelector('.sample').classList.add('show')
                  document.querySelector('.typewriter').classList.add('shrink')
                }
                catch { /* empty */ }
              }, 4000)   
              setTimeout(() =>{
                try{
                  document.querySelector('.sample').classList.remove('show')
                }
                catch { /* empty */ }
              }, 7000)  
          }
        } catch { /* empty */ }        
      },
      getRnd(min, max) {
        return Math.floor(Math.random() * (max - min + 1) ) + min;
      }
  },
  mounted(){
    //this.animateLetters()
    if(this.animate && !this.typewriterAnimation){
      setTimeout(this.animateTypewriter, 1000)
      this.typewriterAnimation = setInterval(this.animateTypewriter, 13000)
    }
    if(this.animate && !this.letterAnimation){
      setTimeout(()=>{
        this.animateLetters()
        this.letterAnimation = setInterval(this.animateLetters, (this.animationDuration + this.transitionTime + 1)*1000)
      }, 3000)
    }       
  },
  beforeDestroy(){
    clearInterval(this.typewriterAnimation)
    clearInterval(this.letterAnimation)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.dark .banner{
  
  &.nobgcolor{
    //background: var(--color-bg);
    background: linear-gradient(180deg, #303030 0%, var(--color-bg) 100%);
  }
}

.banner{
  height: 200px;  
  width: 100%;
  background-color: var(--color-banner-bg);

  @media (min-width: $S) {
    height:230px;
  }

  @media (min-width: $M) {
    height:250px;    
  }

  @media (min-width: $L) {
    height:280px;
  }

  @media (min-width: $XL) {
    height:300px;
  }

  .sample{
    position: absolute;
    z-index: 3;
    width: 256px;
    height: 70px;
    top: 37%;
    background: url(../assets/images/banner_sample3.jpg) center/cover no-repeat;
    left: 50%;
    margin-left:-128px;
    transform: scaleY(0);
    box-shadow: 0 0 65px 0 rgb(44, 44, 44);

    @media (min-width: $S) {
      width: 292px;
      height: 80px;
      margin-left:-146px;
    }

    @media (min-width: $M) {
      width: 328px;
      height: 90px;
      margin-left:-164px;
    }

    @media (min-width: $L) {
      width: 364px;
      height: 100px;
      margin-left:-182px;
    }

    @media (min-width: $XL) {
      width: 400px;
      height: 110px;
      margin-left:-200px;
    }

    &.show{
      transform: scaleY(1);
      transition: transform .5s ease;
      transition-delay: .5s;
    }
  }

  .typewriter{    
    position: absolute;
    z-index: 3;
    text-align: center;
    width: 100%;
    font-size: 28px;
    top: 44%;  

    @media (min-width: $S) {
      font-size: 32px;
    }

    @media (min-width: $M) {
      font-size: 36px;
    }

    @media (min-width: $L) {
      font-size: 38px;
    }
    
    @media (min-width: $XL) {
      font-size: 40px;
    }

    div {
      background-color: black;
      padding: 10px 20px;
      width: auto;
      display: inline-block;

        span{
        color: white;
        margin: 0;
        border-right: .15em solid orange;
        animation: blink-caret .75s step-end infinite;
      }    
    }  
    
    &.shrink{
      div{
        transition: transform .5s ease;
        transform: scaleY(0);
      }
    }
  }

  @keyframes blink-caret {
    from, to { border-color: transparent }
    50% { border-color: orange; }
  }

  .slideshow{
    height: 100%; 
    background: url(../assets/images/budapest.jpg) no-repeat center;
    background-size: cover;
    max-width: $XL;
    margin: 0 auto;
    position: relative;
  }

  .slide{
    width: 100%;
    height: 100%;  
    //background: url(../assets/images/banner-transparent.png) center/cover no-repeat;
    opacity: 0;
    // max-width: $XL;
    // margin: 0 auto;  
    position: absolute;
    //transition: background 3s ease;
    transition: opacity 3s ease;
    z-index: 1;
        
    &.cover{
      z-index: 2;
      //opacity: 1;
      //transition: background 3s ease; 
      background: url(../assets/images/banner.jpg) center/cover no-repeat;
      transition: opacity 3s ease;

      &:hover{
        // background: url(../assets/images/banner.jpg) center/cover no-repeat;
        // // transition: none;
        // transition: background 3s ease; 
        transition: opacity 3s ease;
        opacity: 1;       
      }
    }

    &.show{       
      transition: opacity 1s ease;
      opacity: 1;
    }

    &#banner-p{ 
      background: url(../assets/images/banner-p.png) center/cover no-repeat; 
    }
    &#banner-k{ 
      background: url(../assets/images/banner-k.png) center/cover no-repeat; 
    }
    &#banner-v{ 
      background: url(../assets/images/banner-v.png) center/cover no-repeat; 
    }
    &#banner-b{ 
      background: url(../assets/images/banner-b.png) center/cover no-repeat; 
    }
    &#banner-t{ 
      background: url(../assets/images/banner-t.png) center/cover no-repeat; 
    }
    &#banner-t2{ 
      background: url(../assets/images/banner-t2.png) center/cover no-repeat; 
    }
    &#banner-e{ 
      background: url(../assets/images/banner-e.png) center/cover no-repeat; 
    }
  }  
}

</style>
